import { Button, Grid } from '@material-ui/core';
import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import React, { useCallback } from 'react';
import styled from 'styled-components';
import { useSubstate } from 'use-substate';

import client from 'core/http/client';
import { LoginSchema } from 'core/schemas/login';
import { Login } from 'core/Store/auth/actions';

import TokenResponse from '../TokenResponse';

const WhiteButton = styled(Button)`
  color: white !important;
`;

const messages: { [key: string]: string } = {
  'Invalid credentials': 'Väärä käyttäjätunnus tai salasana',
  Inactive: 'Käyttäjätunnusta ei ole aktivoitu',
  'Insufficient permissions': 'Sinulla ei ole oikeuksia kirjautua tänne',
  Unknown: 'Kirjautuminen epäonnistui, yritä myöhemmin uudelleen'
};

export default function useLogin() {
  const { enqueueSnackbar } = useSnackbar();
  const [, dispatch] = useSubstate(() => null);

  const login = useCallback(
    (credentials: LoginSchema) => {
      return client()
        .post<TokenResponse>('auth/login', credentials)
        .then(
          response => response.data.access_token,
          (error: AxiosError) => {
            if (!error.response) {
              throw messages['Unknown'];
            }

            if ([401, 403].indexOf(error.response.status) >= 0) {
              if (error.response.status === 403) {
                enqueueSnackbar(<EmployeeMobileApp />, { variant: 'info' });
                enqueueSnackbar(<CustomersMobileApp />, { variant: 'info' });
              }

              throw messages[
                (error.response.data && error.response.data.error) ||
                  'Invalid credentials'
              ] || messages['Unknown'];
            }

            throw messages['Unknown'];
          }
        )
        .then(token => dispatch(new Login(token)));
    },
    [dispatch, enqueueSnackbar]
  );

  return login;
}

function CustomersMobileApp() {
  return (
    <Grid container alignItems="center" spacing={2}>
      <Grid item>Rengastalli mobiilisovellus (asiakkaille)</Grid>
      <Grid item>
        <WhiteButton size="small" href="/welcome/customer">
          Lataa
        </WhiteButton>
      </Grid>
    </Grid>
  );
}

function EmployeeMobileApp() {
  return (
    <Grid container alignItems="center" spacing={2}>
      <Grid item>Rengashuolto mobiilisovellus (työntekijöille)</Grid>
      <Grid item>
        <WhiteButton size="small" href="/welcome/employee">
          Lataa
        </WhiteButton>
      </Grid>
    </Grid>
  );
}
